import { ToggleButtonGroup, Typography, styled } from '@mui/material';

export const StyledTypographyCredits = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 600,
  marginBottom: 24,
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      marginLeft: '10px',
      marginRight: '10px',
      border: 0,
      borderRadius: 0,
      '&.Mui-disabled': {
        border: 0,
      },
      '&.Mui-selected': {
        backgroundColor: '#5e1f6a',
      },
      '&:not(:first-of-type)': {
        color: '#f6a26a',
        border: '1px solid',
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
      '&:first-of-type': {
        color: '#f6a26a',
        border: '1px solid',
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
    },
  })
);

export const SurvivalToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: 16,
      '&.Mui-disabled': {
        border: 0,
      },
      '&.Mui-selected': {
        backgroundColor: '#002d15',
        border: '1px solid',
        borderColor: '#78917c',
        color: '#8fff0a',
      },
    },
  })
);

export const MultiplayerToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      marginLeft: '10px',
      marginRight: '10px',
      border: 0,
      borderRadius: 0,
      '&.Mui-disabled': {
        border: 0,
      },
      '&.Mui-selected': {
        backgroundColor: '#005a7bb5',
      },
      '&:not(:first-of-type)': {
        color: theme.palette.ranked.main,
        border: '1px solid',
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
      '&:first-of-type': {
        color: theme.palette.info.main,
        border: '1px solid',
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
    },
  })
);

export const CasualProToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      marginLeft: '10px',
      marginRight: '10px',
      border: 0,
      borderRadius: 0,
      '&.Mui-disabled': {
        border: 0,
      },
      '&.Mui-selected': {
        backgroundColor: 'transparent',
        borderBottom: '1px solid',
      },
      '&:not(:first-of-type)': {
        color: theme.palette.info.main,
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
      '&:first-of-type': {
        color: theme.palette.info.main,
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
    },
  })
);

export const SearchToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      marginLeft: '10px',
      marginRight: '10px',
      border: 0,
      borderRadius: 0,
      '&.Mui-disabled': {
        border: 0,
      },
      '&.Mui-selected': {
        backgroundColor: '#005a7bb5',
      },
      '&:not(:first-of-type)': {
        color: theme.palette.dailies.main,
        border: '1px solid',
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
      '&:first-of-type': {
        color: theme.palette.dailies.main,
        border: '1px solid',
        // borderColor: theme.palette.primary.main,
        // borderRadius: theme.shape.borderRadius,
      },
    },
  })
);
